import { ConfirmationModal } from "@/components/ui/ConfirmationModal/ConfirmationModal";

interface ConfirmDeleteFieldModalProps {
  isOpen: boolean;
  fieldName?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmDeleteFieldModal({
  isOpen,
  fieldName,
  onClose,
  onConfirm,
}: ConfirmDeleteFieldModalProps) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete this field?"
      body={
        fieldName
          ? `"${fieldName}" and its settings will be removed from the form.`
          : "This field and its settings will be removed from the form."
      }
      confirmText="Delete field"
      confirmVariant="destructive-primary"
      size="md"
      onConfirm={onConfirm}
    />
  );
}
